// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"993a601f","337":"81b4599a","455":"d7c40d69"}[chunkId] + ".chunk.js";
};